export const colours = {
  c1: '#d40707',
  c2: '#211e1c', // text
  c3: '#ffffff',
  c4: '#ACACAC',
  c5: '#ecebeb',
  c1_h: '#B10606',
  c2_h: '#0F0E0D',
  c_success: '#407E1F',
  c_error: '#d40707',
  c2_transparent: 'rgba(33,30,28,.8)',
  shadow: 'rgba(33,30,28,.4)',
  c3_transparent: 'rgba(255,255,255,.8)',
  c_amethyst: '#7B2D8B',
  c_light_brown: '#e8e4df',
};
